<template v-cloak>
    <NuxtLayout name="main" dark class="bg-[#F7F6FB]">
        <div class="mx-auto my-[56px] px-[64px] py-[62px] w-[1264px] bg-white">
            <div class="text-[44px] leading-[62px] font-bold text-emphas">{{ $t("DataVisualization") }}</div>
            <div class="w-[132px] h-[4px] bg-main mt-[22px] mb-[46px]"></div>
            <div
                class="mb-[40px] pl-[80px] h-[240px] flex flex-col justify-center bg-[url(https://rdgta.cdn.cyagen.com/rddc/pictures/3527f400-5bcd-4954-ab00-0c7b0a866089.webp)] font-bold text-white">
                <div v-if="$i18n.locale == 'en'" class="text-[36px] leading-[52px]">
                    <p>{{ $t("DataVisualizationI18n.Name1") }}</p>
                    <p class="mt-[8px]">Data through Visualization</p>
                </div>
                <div v-else>
                    <p class="text-[40px] leading-[56px]">{{ $t("DataVisualizationI18n.Name1") }}</p>
                </div>
            </div>
            <p class="text-[16px]">{{ $t("DataVisualizationI18n.Descript1") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("DataVisualizationI18n.Descript2") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("DataVisualizationI18n.Descript3") }}</p>
        </div>
    </NuxtLayout>
</template>
